import React from 'react';
import ActivityBadge from './ActivityBadge';
import type { AuditActivity } from '../../../../../types/auditLogs';

interface AuditActivityCardProps {
  activity: AuditActivity;
}

const AuditActivityCard: React.FC<AuditActivityCardProps> = ({ activity }) => {
  const formatTimestamp = (timestamp: Date): string => {
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - timestamp.getTime()) / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now.getTime() - timestamp.getTime()) / (1000 * 60));
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays === 1) {
      return `Yesterday, ${timestamp.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      })}`;
    } else if (diffInDays < 7) {
      return `${diffInDays} days ago`;
    } else {
      return timestamp.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }
  };

  return (
    <div className="audit-activity-card">
      <div className="activity-icon">
        <ActivityBadge type={activity.type} />
      </div>
      <div className="activity-content">
        <div className="activity-header">
          <h4 className="activity-title">{activity.title}</h4>
          <span className="activity-timestamp">
            {formatTimestamp(activity.timestamp)}
          </span>
        </div>
        <p className="activity-description">{activity.description}</p>
      </div>
    </div>
  );
};

export default AuditActivityCard;